import { computed } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import type ICoordinate from '../interfaces/coordinates';

interface IProps {
  points: Array<ICoordinate>;
  strokeColor: string;
  strokeWidth: number;
}

@observer
class Path extends React.Component<IProps> {
  static defaultProps: Partial<IProps> = {
    strokeWidth: 2,
    strokeColor: 'black'
  };

  constructPath(points: Array<ICoordinate>) {
    let pathStr, midX, midY, distance, j;

    if (points.length <= 2) {
      return '';
    }
    pathStr = `M${points[0].x},${points[0].y} `;
    for (let i = 1; i < points.length - 2; ) {
      j = 2;
      distance = (first: number, next: number) => {
        return Math.sqrt(
          Math.pow(points[first].x - points[first + next].x, 2) +
            Math.pow(points[first].y - points[first + next].y, 2)
        );
      };

      while (i + j < points.length - 2 && distance(i, j) < 1) {
        j++;
      }

      midX = (points[i].x + points[i + j].x) / 2;
      midY = (points[i].y + points[i + j].y) / 2;
      pathStr += `Q${points[i].x},${points[i].y} ${midX},${midY} `;
      i += j;
    }

    return pathStr;
  }

  @computed
  get pathData() {
    return this.constructPath(this.props.points);
  }

  render() {
    const { strokeColor, strokeWidth } = this.props;

    return (
      <path
        fill="none"
        stroke={strokeColor || 'black'}
        strokeWidth={strokeWidth || 2}
        strokeLinejoin="round"
        strokeLinecap="round"
        d={this.pathData}
      />
    );
  }
}

export default Path;
